import u from "../../bundled_deps/.pnpm/camelcase@8.0.0/bundled_deps/camelcase/index.js";
const n = "embercom-prosemirror-retry-upload", o = "file-guid";
function f(t) {
  t.attrs = Object.assign({}, t.attrs, {
    fileGUID: { default: "" },
    uploadFailed: { default: !1 },
    failureReason: { default: "" },
    retryable: { default: !0 }
  });
  const e = t.toDOM;
  return t.toDOM = (l) => {
    const a = l.attrs, r = e(l);
    if (Array.isArray(r) && r.length > 1 && (r[1][o] = a?.fileGUID), a?.uploadFailed === !0) {
      let s = [];
      if (a.retryable) {
        const i = { class: n };
        i[`data-${o}`] = a?.fileGUID, s = ["a", i, "try again"];
      }
      return [
        "div",
        { class: "embercom-prosemirror-upload-failed" },
        [
          "div",
          { class: "embercom-prosemirror-upload-failed-inner" },
          [
            "div",
            { class: "embercom-prosemirror-upload-info" },
            d(),
            l.attrs.failureReason
          ],
          s
        ],
        r
      ];
    }
    return r;
  }, t;
}
function p(t, e) {
  e.target?.classList.contains(n) && t?.commands.retryUpload(e.target.dataset[u(o)]);
}
function m(t) {
  return t.type === "success" ? { fileGUID: "", uploadFailed: !1, failureReason: "" } : {
    uploadFailed: !0,
    failureReason: t.reason,
    retryable: t.retryable
  };
}
function d() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttributeNS(null, "fill", "red"), t.setAttribute("class", "interface-icon o__standard o__by-text"), t.setAttributeNS(null, "viewBox", "0 0 16 16");
  const e = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return e.setAttributeNS(null, "fill-rule", "oddeven"), e.setAttributeNS(
    null,
    "d",
    "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-6.083a.701.701 0 0 1-.697-.621L6.88 4.615A1 1 0 0 1 7.872 3.5h.256a1 1 0 0 1 .993 1.115l-.424 3.68A.701.701 0 0 1 8 8.918zM8 12.5c-.714 0-1.25-.536-1.25-1.25S7.286 10 8 10s1.25.536 1.25 1.25S8.714 12.5 8 12.5z"
  ), t.appendChild(e), t;
}
export {
  o as UPLOAD_FILE_GUID,
  n as UPLOAD_RETRY_CLASS,
  p as handleUploadRetry,
  m as uploadResultToNodeAttrs,
  f as uploadable
};
